import React from 'react'
import CheckoutSteps from './CheckoutSteps';
import {useSelector, useDispatch} from 'react-redux';
import {Link, useHistory} from 'react-router-dom'
import {createOrder} from '../redux/order/orderActions';


const CheckoutConfirm = () => {

  const {cartItems, paymentMethod, shippingAddress} = useSelector(state => state.cart);
  const history = useHistory();
  const dispatch = useDispatch();

  if(!cartItems || !paymentMethod || !shippingAddress){
    history.push('/')
  }

  let totalPrice = cartItems.reduce((acc, item) => acc + item.product.price * item.qty, 0);

  const orderHandler = () =>{
    console.log('order Placed');
    let order = {
      orderItems : cartItems,
      paymentMethod : paymentMethod,
      shippingAddress : shippingAddress,
      totalPrice
    }

    dispatch(createOrder(order))
    
    history.push('/')
  }
  
  return (
    <div className="pageContainer">
      
      <CheckoutSteps step1 step2 step3 step4/>

        <div className="pageHeader">
            <p>Confirm Order</p>
        </div>

        <div className="pageBody">
          <div>
            <b>SHIPPING ADDRESS</b> : {shippingAddress.address},{' '}
                                {shippingAddress.city},{' '}
                                {shippingAddress.postalCode},{' '}
                                {shippingAddress.country}
          </div>

          <div>
            <b>PAYMENT METHOD</b> : {paymentMethod}
          </div>

          <div>
            <b>ORDERED ITEMS</b>
            <div>
            {cartItems.length === 0 ? <div>Your cart is empty</div> :
                <div className="pageBody cols">
                    <ul>
                        {cartItems.map((item) => 
                        <li className="cart-item">
                          <Link className="nav product-details" to={`/product/${item.product._id}`}>
                              <img src={item.product.image} alt={item.product.name}/>
                              {item.product.name}
                          </Link>
                          <div>
                            ₹{item.product.price} x {item.qty}
                          </div>
                        </li>)}
                    </ul>
                </div>}
            </div>
          </div>

          <div>
            <h3>Total Price : ₹{totalPrice}</h3> 
            <button className="btn" onClick={orderHandler}>Place Order</button>
          </div>

        </div>
    </div>
  )
}

export default CheckoutConfirm